import React, { useMemo } from "react";
import { isUserEditableNode } from "../../../../../Components/Tree/TreeUtils";
import { useQuery } from "@apollo/client";
import Tree from "../../../../../Components/Tree/Tree";
import type { TreeNode } from "../../../../../Components/Tree/types";
import { GET_SCOPE_HIERARCHY_BY_PROFILES } from "../../../../Permissions/PermissionsApi";
import "./AllowedScopes.scss";
import { resourceTypes } from "../../../../../Findings/FindingsUtils";
import { TextButton } from "@SeemplicityDev/shared";

interface AllowedScopesProfile {
  id?: string;
}

interface AllowedScopesProps {
  onClosingAllowedScopes: () => void;
  profiles?: AllowedScopesProfile[] | null;
}

interface ScopeHierarchyByProfilesData {
  scope_hierarchy_by_profiles?: {
    scope_hierarchy?: string;
  } | null;
}

interface ScopeHierarchyByProfilesVariables {
  profile_ids?: string[];
}

const AllowedScopes: React.FC<AllowedScopesProps> = ({
  onClosingAllowedScopes,
  profiles = null,
}) => {
  const { data } = useQuery<
    ScopeHierarchyByProfilesData,
    ScopeHierarchyByProfilesVariables
  >(GET_SCOPE_HIERARCHY_BY_PROFILES, {
    variables: {
      profile_ids: profiles?.reduce<string[]>((acc, profile) => {
        if (profile.id) {
          acc.push(profile.id);
        }
        return acc;
      }, []),
    },
    skip: !profiles,
    fetchPolicy: "network-only",
  });

  const treeData = useMemo<TreeNode[] | undefined>(() => {
    if (!!data) {
      const scopesList: TreeNode[] | null = JSON.parse(
        data?.scope_hierarchy_by_profiles?.scope_hierarchy as string
      );

      const newRoot: TreeNode = { ...(!!scopesList ? scopesList[0] : null) };
      if (newRoot?.children?.length) {
        newRoot.children = newRoot?.children?.filter(isUserEditableNode);
      }

      if (Object.keys([newRoot][0]).length) {
        return [newRoot];
      } else {
        return [];
      }
    }
  }, [data]);

  return (
    <div className={"allowed-scopes-wrapper"}>
      <TextButton
        wrapperClassName={"back-to-integrations"}
        data-testid={"back-to-btn"}
        type={"button"}
        leftIcon={"seem-icon-left-arrow"}
        label={"Back"}
        buttonStyle={"textLink"}
        onClick={onClosingAllowedScopes}
      />
      <h4>Allowed Groups & Scopes</h4>
      <div className={"allowed-scopes-tree"}>
        <Tree
          data={treeData}
          nodeOperations={{}}
          data-testid={"profile-scopes-selection-tree"}
          isSelectableNode={(node) => node.type !== resourceTypes.ROOT}
          readOnly
        />
      </div>
    </div>
  );
};

export default AllowedScopes;
